import React, {Component} from 'react'
import BoxElementItem from './BoxElementItem.js'
import update from 'react-addons-update';
import deepEqual from 'deep-equal'
import _ from 'lodash'
import ResponsiveManager from '../../ResponsiveManager'

class BoxElement extends Component {

  constructor(props){
    super(props)


    let dirObject = {
      top:'',
      right:'',
      bottom:'',
      left:''
    }

    if(this.props.params.responsive){
      dirObject = {
        md: {
            top:'',
            right:'',
            bottom:'',
            left:''
          },
        sm: {
            top:'',
            right:'',
            bottom:'',
            left:''
          },
        xs: {
            top:'',
            right:'',
            bottom:'',
            left:''
          }
      }
    }

    let locked = false;

    if(this.props.params.responsive){
      locked = {
        md: false,
        sm: false,
        xs: false,
      };
    }

    this.state = {
      dirObject: dirObject,
      locked: locked
    }
    this.onChangeHandle = this.onChangeHandle.bind(this)
  }

  componentDidMount(){
    const { input, params } = this.props
    var newDirObject = this.getObjectFromStringValue(input.value);
    
    this.setState({
      dirObject: newDirObject,
      locked: this.checkLock(input.value)
    })
    
  }

  componentWillReceiveProps(nextProps){
    var newDirObject = this.getObjectFromStringValue(nextProps.input.value);

    if(!deepEqual(newDirObject, this.state.dirObject)){
      this.setState({
        dirObject: newDirObject,
        locked: this.checkLock(nextProps.input.value)
      })
    }
  }

  checkLock(value){
    var locked;
    if(this.props.params.responsive && _.isObject(value)){
        locked = {
          md: false,
          sm: false,
          xs: false,
        };
      _.each(value, (dirObjectResp, device) => {
        var values = dirObjectResp.split(' ');
        if( values[0] == values[1] && values[1] == values[2] && values[2] == values[3] ){
          locked[device] = true;
        }
      });
    } else if(this.props.params.responsive && !_.isObject(value)){
        locked = {
          md: false,
          sm: true,
          xs: true,
        };
        
        var values = value.split(' ');
        if( values[0] == values[1] && values[1] == values[2] && values[2] == values[3] ){
          locked.md = true;
        }
      
    } else {
      locked = false;
      var values = value.split(' ');
      if( values[0] == values[1] && values[1] == values[2] && values[2] == values[3] ){
        locked = true;
      }
    }

    return locked;
  }

  getObjectFromStringValue(value){
    const { params } = this.props

    var dirObject = {};

    if(params.responsive && _.isObject(value)){
      _.each(value, (dirObjectResp, device) => {
        var boxArrayResp = dirObjectResp.split(' ')
        var dirObjectResp = {
          top: '',
          right: '',
          bottom: '',
          left: '',
        };

        dirObjectResp.top = boxArrayResp[0];

        if (typeof boxArrayResp[1] !=='undefined') {
          dirObjectResp.right = boxArrayResp[1]
        }

        if (typeof boxArrayResp[2] !=='undefined') {
          dirObjectResp.bottom = boxArrayResp[2]
        }

        if (typeof boxArrayResp[3] !=='undefined') {
          dirObjectResp.left = boxArrayResp[3]
        }

        dirObject[device] = dirObjectResp;
      })
    } else if(params.responsive && !_.isObject(value)){
      dirObject = {
        md: {
          top: '',
          right: '',
          bottom: '',
          left: '',
        },
        sm: {
          top: '',
          right: '',
          bottom: '',
          left: '',
        },
        xs: {
          top: '',
          right: '',
          bottom: '',
          left: '',
        }
      };

      var newBoxArray = value.split(' ')

      dirObject.md.top = newBoxArray[0];

      if (typeof newBoxArray[1] !=='undefined') {
        dirObject.md.right = newBoxArray[1]
      }

      if (typeof newBoxArray[2] !=='undefined') {
        dirObject.md.bottom = newBoxArray[2]
      }

      if (typeof newBoxArray[3] !=='undefined') {
        dirObject.md.left = newBoxArray[3]
      }
    } else {
      var boxArray = value.split(' ')
      var dirObject = {
        top: '',
        right: '',
        bottom: '',
        left: '',
      };

      dirObject.top = boxArray[0];

      if (typeof boxArray[1] !=='undefined') {
        dirObject.right = boxArray[1]
      }

      if (typeof boxArray[2] !=='undefined') {
        dirObject.bottom = boxArray[2]
      }

      if (typeof boxArray[3] !=='undefined') {
        dirObject.left = boxArray[3]
      }
    }

    return dirObject;
  }

  onChangeHandle(event){
    const { params } = this.props

    var direction = event.target.getAttribute('data-direction');
    var device = event.target.getAttribute('data-device');
    var dirVal = ' ';

    if (event.target.value !== '') {
      dirVal = event.target.value;
    }

    const { dirObject} = this.state;

    var newObj = {};

    if(params.responsive){
      if(this.state.locked[device]){
        var newObjTmp = {
          top: dirVal,
          right: dirVal,
          bottom: dirVal,
          left: dirVal
        }
      } else {
        var newObjTmp = update(
          dirObject[device],
          {
            [direction]:{$set: dirVal}
          }
        );
      }
      
      newObj = update(dirObject, { [device]:{$set: newObjTmp}});
    } else {
      if(this.state.locked){
        newObj = update(dirObject, {
          top:{$set: dirVal},
          right:{$set: dirVal},
          bottom:{$set: dirVal},
          left:{$set: dirVal},
        });
      } else {
        newObj = update(dirObject, { [direction]:{$set: dirVal}});
      }
      
    }

    this.setState({dirObject:newObj})
  }

  componentDidUpdate(){
    this.getStringFromBoxModelObject()
  }

  getStringFromBoxModelObject(){
    const { dirObject } = this.state
    const { input: { onChange }, params } = this.props

    var standardValue;

    if(params.responsive){
      standardValue = {
        md: {},
        sm: {},
        xs: {}
      };

      _.each(dirObject, (dirObjectResp, device) => {
        var standardValueResp = '';
        if (typeof dirObjectResp.top !== 'undefined' && dirObjectResp.top !== '') {
            standardValueResp += dirObjectResp.top.trim() + ' ';
        } else {
          standardValueResp += '' + ' ';
        }

        if (typeof dirObjectResp.right !== 'undefined' && dirObjectResp.right !== '') {
            standardValueResp += dirObjectResp.right.trim() + ' ';
        } else {
          standardValueResp += '' + ' ';
        }

        if (typeof dirObjectResp.bottom !== 'undefined' && dirObjectResp.bottom !== '') {
            standardValueResp += dirObjectResp.bottom.trim() + ' ';
        } else {
          standardValueResp += '' + ' ';
        }

        if (typeof dirObjectResp.left !== 'undefined' && dirObjectResp.left !== '') {
            standardValueResp += dirObjectResp.left.trim();
        } else {
          standardValueResp += '';
        }

        standardValue[device] = standardValueResp;
      })

    } else {
      standardValue = '';
      if (typeof dirObject.top !== 'undefined' && dirObject.top !== '') {
          standardValue += dirObject.top.trim() + ' ';
      } else {
        standardValue += '' + ' ';
      }

      if (typeof dirObject.right !== 'undefined' && dirObject.right !== '') {
          standardValue += dirObject.right.trim() + ' ';
      } else {
        standardValue += '' + ' ';
      }

      if (typeof dirObject.bottom !== 'undefined' && dirObject.bottom !== '') {
          standardValue += dirObject.bottom.trim() + ' ';
      } else {
        standardValue += '' + ' ';
      }

      if (typeof dirObject.left !== 'undefined' && dirObject.left !== '') {
          standardValue += dirObject.left.trim();
      } else {
        standardValue += '';
      }
    }

    onChange( standardValue );
  }

  render(){
    const { input, params, responsiveDevice } = this.props
    const { dirObject, locked } = this.state;

    var activeClassName = 'sp-pagebuilder-device-tabs sp-pagebuilder-device-'+responsiveDevice;

    return(
      <div className="sp-pagebuilder-form-group">
        <label className="clearfix">
          { params.title }
          {
            !params.responsive
            ?
            <span style={{padding: '0px 8px'}} onClick={e => {
              e.preventDefault();
              this.setState({
                locked: !locked
              })
              }}>
              {
                locked
                ?
                <i className="fa fa-lock"/>
                :
                <i className="fa fa-unlock-alt"/>
              }
            </span>
            :
            _.map(dirObject, (dirObjectResp, device) => {
              let lockStyle = {
                padding: '0px 8px',
                display: 'none',
                cursor: 'pointer'
              }
              if(responsiveDevice == device){
                lockStyle.display = 'inline-block';
              }
              return(
                <span style={lockStyle} key={device} onClick={e => {
                  e.preventDefault();
                  var newLocked = update(locked, { [device]:{$set: !locked[device]}});
                  this.setState({
                    locked: newLocked
                  })
                  }}>
                  {
                    locked[device]
                    ?
                    <i className="fa fa-lock"/>
                    :
                    <i className="fa fa-unlock-alt"/>
                  }
                </span>
              )
            })
          }
          
          {
            params.responsive &&
            <ul className={activeClassName}>
              <li><i className="fa fa-laptop md" onClick={e => {
                  ResponsiveManager.setDevice('md');
                }}></i></li>
              <li><i className="fa fa-tablet sm" onClick={e => {
                  ResponsiveManager.setDevice('sm');
                }}></i></li>
              <li><i className="fa fa-mobile xs" onClick={e => {
                  ResponsiveManager.setDevice('xs');
                }}></i></li>
            </ul>
          }
        </label>
        {
          params.responsive &&
          _.map(dirObject, (dirObjectResp, device) => {
            var containerClass = "sppb-box-element clearfix sp-pagebuilder-margins-list sppb-box-element-"+device;

            if(responsiveDevice == device){
              containerClass += ' active';
            }
            return (
              <div className={containerClass} key={device}>
                <BoxElementItem
                    direction="top"
                    device={device}
                    elmValue = { dirObjectResp.top }
                    itemChangeHandle = {this.onChangeHandle}
                />
                <BoxElementItem
                    direction="right"
                    device={device}
                    elmValue = { dirObjectResp.right }
                    itemChangeHandle = {this.onChangeHandle}
                />
                <BoxElementItem
                    direction="bottom"
                    device={device}
                    elmValue = { dirObjectResp.bottom }
                    itemChangeHandle = {this.onChangeHandle}
                />
                <BoxElementItem
                    direction="left"
                    device={device}
                    elmValue = { dirObjectResp.left }
                    itemChangeHandle = {this.onChangeHandle}
                />
              </div>
            )
          })
        }
        {
          !params.responsive &&
          <div className="sppb-box-element clearfix sp-pagebuilder-margins-list">
            <BoxElementItem
                direction="top"
                elmValue = { dirObject.top }
                itemChangeHandle = {this.onChangeHandle}
            />
            <BoxElementItem
                direction="right"
                elmValue = { dirObject.right }
                itemChangeHandle = {this.onChangeHandle}
            />
            <BoxElementItem
                direction="bottom"
                elmValue = { dirObject.bottom }
                itemChangeHandle = {this.onChangeHandle}
            />
            <BoxElementItem
                direction="left"
                elmValue = { dirObject.left }
                itemChangeHandle = {this.onChangeHandle}
            />
          </div>
        }

      </div>
    )
  }
}

export default BoxElement;



// WEBPACK FOOTER //
// ./src/helpers/form/types/BoxElement.js